import React, { useState } from 'react';
import './Dashboard.css';

// Minimal SVG Icons
const Icons = {
  Close: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="18" y1="6" x2="6" y2="18"/>
      <line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  Overview: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
      <line x1="9" y1="9" x2="15" y2="9"/>
      <line x1="9" y1="12" x2="15" y2="12"/>
      <line x1="9" y1="15" x2="15" y2="15"/>
    </svg>
  ),
  Conversations: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>
  ),
  Mapping: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
    </svg>
  ),
  Settings: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  )
};

const Dashboard = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedConversation, setSelectedConversation] = useState(null);

  // Mock data for the dashboard
  const stats = {
    totalConversations: 1247,
    activeChats: 23,
    conversionRate: 12.4,
    avgResponseTime: '2.3s'
  };

  const recentConversations = [
    {
      id: 1,
      customer: 'Sarah M.',
      lastMessage: 'Is this dress available in size M?',
      time: '2 min ago',
      status: 'active',
      product: 'Blue Summer Dress'
    },
    {
      id: 2,
      customer: 'Mike R.',
      lastMessage: 'What\'s the return policy?',
      time: '5 min ago',
      status: 'pending',
      product: 'Black Leather Jacket'
    },
    {
      id: 3,
      customer: 'Emma L.',
      lastMessage: 'Thank you for the help!',
      time: '12 min ago',
      status: 'resolved',
      product: 'White Sneakers'
    },
    {
      id: 4,
      customer: 'John D.',
      lastMessage: 'Can you show me similar items?',
      time: '18 min ago',
      status: 'active',
      product: 'Red Backpack'
    }
  ];

  const productMappings = [
    {
      id: 1,
      igPost: '@yourstore summer collection',
      product: 'Blue Summer Dress',
      confidence: 94,
      status: 'mapped'
    },
    {
      id: 2,
      igPost: '@yourstore new arrivals',
      product: 'Black Leather Jacket',
      confidence: 87,
      status: 'mapped'
    },
    {
      id: 3,
      igPost: '@yourstore casual wear',
      product: 'White Sneakers',
      confidence: 76,
      status: 'review'
    }
  ];

  if (!isOpen) return null;

  return (
    <div className="dashboard-overlay">
      <div className="dashboard-container">
        {/* Header */}
        <div className="dashboard-header">
          <div className="header-left">
            <div className="brand">
              <span className="brand-text">Merchant Console</span>
            </div>
          </div>
          <div className="header-right">
            <button className="close-btn" onClick={onClose}>
              <Icons.Close />
            </button>
          </div>
        </div>

        {/* Navigation Tabs */}
        <div className="dashboard-nav">
          <button 
            className={`nav-tab ${activeTab === 'overview' ? 'active' : ''}`}
            onClick={() => setActiveTab('overview')}
          >
            <Icons.Overview />
            <span>Overview</span>
          </button>
          <button 
            className={`nav-tab ${activeTab === 'conversations' ? 'active' : ''}`}
            onClick={() => setActiveTab('conversations')}
          >
            <Icons.Conversations />
            <span>Conversations</span>
          </button>
          <button 
            className={`nav-tab ${activeTab === 'mapping' ? 'active' : ''}`}
            onClick={() => setActiveTab('mapping')}
          >
            <Icons.Mapping />
            <span>Product Mapping</span>
          </button>
          <button 
            className={`nav-tab ${activeTab === 'settings' ? 'active' : ''}`}
            onClick={() => setActiveTab('settings')}
          >
            <Icons.Settings />
            <span>Settings</span>
          </button>
        </div>

        {/* Content Area */}
        <div className="dashboard-content">
          {activeTab === 'overview' && (
            <div className="overview-content">
              {/* Stats Cards */}
              <div className="stats-grid">
                <div className="stat-card">
                  <div className="stat-label">Total Conversations</div>
                  <div className="stat-value">{stats.totalConversations.toLocaleString()}</div>
                </div>
                <div className="stat-card">
                  <div className="stat-label">Active Chats</div>
                  <div className="stat-value">{stats.activeChats}</div>
                </div>
                <div className="stat-card">
                  <div className="stat-label">Conversion Rate</div>
                  <div className="stat-value">{stats.conversionRate}%</div>
                </div>
                <div className="stat-card">
                  <div className="stat-label">Avg Response Time</div>
                  <div className="stat-value">{stats.avgResponseTime}</div>
                </div>
              </div>

              {/* Recent Activity */}
              <div className="section">
                <h3 className="section-title">Recent Activity</h3>
                <div className="activity-list">
                  {recentConversations.slice(0, 3).map(conv => (
                    <div key={conv.id} className="activity-item">
                      <div className="activity-main">
                        <span className="customer-name">{conv.customer}</span>
                        <span className="activity-message">{conv.lastMessage}</span>
                      </div>
                      <div className="activity-meta">
                        <span className={`status-badge ${conv.status}`}>{conv.status}</span>
                        <span className="activity-time">{conv.time}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {activeTab === 'conversations' && (
            <div className="conversations-content">
              <div className="section">
                <h3 className="section-title">Customer Conversations</h3>
                <div className="conversations-list">
                  {recentConversations.map(conv => (
                    <div 
                      key={conv.id} 
                      className={`conversation-item ${selectedConversation === conv.id ? 'selected' : ''}`}
                      onClick={() => setSelectedConversation(conv.id)}
                    >
                      <div className="conversation-header">
                        <span className="customer-name">{conv.customer}</span>
                        <span className="conversation-time">{conv.time}</span>
                      </div>
                      <div className="conversation-preview">
                        <span className="last-message">{conv.lastMessage}</span>
                        <span className="product-context">Re: {conv.product}</span>
                      </div>
                      <div className="conversation-footer">
                        <span className={`status-badge ${conv.status}`}>{conv.status}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {activeTab === 'mapping' && (
            <div className="mapping-content">
              <div className="section">
                <h3 className="section-title">Instagram Post Mappings</h3>
                <div className="mappings-list">
                  {productMappings.map(mapping => (
                    <div key={mapping.id} className="mapping-item">
                      <div className="mapping-main">
                        <span className="ig-post">{mapping.igPost}</span>
                        <span className="mapped-product">→ {mapping.product}</span>
                      </div>
                      <div className="mapping-meta">
                        <span className="confidence-badge">{mapping.confidence}% confidence</span>
                        <span className={`status-badge ${mapping.status}`}>{mapping.status}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {activeTab === 'settings' && (
            <div className="settings-content">
              <div className="section">
                <h3 className="section-title">Assistant Configuration</h3>
                <div className="settings-grid">
                  <div className="setting-item">
                    <label className="setting-label">Response Tone</label>
                    <select className="setting-input">
                      <option>Friendly & Professional</option>
                      <option>Casual & Fun</option>
                      <option>Formal & Business</option>
                    </select>
                  </div>
                  <div className="setting-item">
                    <label className="setting-label">Auto-Response Delay</label>
                    <input type="range" min="0" max="5" defaultValue="2" className="setting-slider" />
                    <span className="setting-value">2 seconds</span>
                  </div>
                  <div className="setting-item">
                    <label className="setting-label">Learning Mode</label>
                    <input type="checkbox" className="setting-checkbox" defaultChecked />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 